// Immutable storage key formats. Ownership comes from the complete key, never
// from a mutable or corrupt request body. Unknown/legacy keys remain untouched.
export const intentStoreScopes = {
  ticketReply: [
    'scrambl-ticket-reply-intents-v1',
    'ticket-reply:v1:',
    ['id', 'id', 'nullable-id', 'id'],
  ],
  financial: [
    'scrambl-financial-intents-v1',
    'financial-operation:v1:',
    ['id', 'id', 'nullable-id', 'financial-kind', 'id'],
  ],
  billingRun: [
    'scrambl-billing-run-intents-v1',
    'billing-run:v1:',
    ['id', 'id', 'nullable-id', 'id'],
  ],
  portalTask: [
    'scrambl-portal-task-intents-v1',
    'portal-task-create:v1:',
    ['id', 'id', 'id', 'id'],
  ],
  portalTaskOrder: [
    'scrambl-portal-task-order-intents-v1',
    'portal-task-order:v1:',
    ['id', 'id', 'id', 'id'],
  ],
  bennyHandoff: [
    'scrambl-benny-handoffs-v1',
    'benny-handoff:v1:',
    ['id', 'id', 'id'],
  ],
} as const
export type IntentStoreKind = keyof typeof intentStoreScopes
